export const PAGE_TYPE_CATEGORY = 'category'
export const PAGE_TYPE_CONTENT = 'content'
export const PAGE_TYPE_ERROR = 'error'
export const PAGE_TYPE_HOMEPAGE = 'homepage'
export const PAGE_TYPE_ORDERPRINT = 'orderprint'
export const PAGE_TYPE_PRODUCT = 'product'
export const PAGE_TYPE_SEARCH_RESULTS = 'search'
export const PAGE_TYPE_TOPIC_SHOW = 'topic_show'
export const PAGE_TYPE_TOPIC_SHOP = 'topic_shop'
export const PAGE_TYPE_LOGIN = 'login'
export const PAGE_TYPE_CHECKOUT = 'checkout'
export const PAGE_TYPE_BRANDSHOPS = 'markenshops'
export const PAGE_TYPE_BRAND_PAGE = 'marken'
export const PAGE_TYPE_DELIVERYTRACKING = 'deliverytracking'
export const PAGE_TYPE_ONLINEDOCTORSERVICE = 'service_od'
export const PAGE_TYPE_CONFIRMATION = 'confirmation'
export const PAGE_TYPE_OFFERS = 'offers'
export const PAGE_TYPE_NEWSLETTER = 'newsletter'
export const PAGE_TYPE_NEWSLETTER_CONFIRMATION = 'newsletter-confirmation'
export const PAGE_TYPE_NEWSLETTER_UNSUBSCRIPTION = 'newsletter-unsubscription'
export const PAGE_TYPE_CART_INTERMEDIATE = 'cartintermediate'
export const PAGE_TYPE_CART = 'cart'
export const PAGE_TYPE_MARKETING = 'marketing'
export const PAGE_TYPE_LEGACY = 'legacy'
export const PAGE_TYPE_ACCOUNT = 'account'
export const PAGE_TYPE_ORDERS_LIST = 'orders_list'
export const PAGE_TYPE_ORDER_OVERVIEW = 'order_overview'
export const PAGE_TYPE_ORDER_DETAILS = 'order_details'
export const PAGE_TYPE_UNKNOWN = 'page_type_unknown'
export const PAGE_TYPE_THREADS_OVERVIEW = 'threads_overview'
export const PAGE_TYPE_THREAD_DETAILS = 'thread_details'
export const PAGE_TYPE_WEB_VIEWS_THREAD_NEW = 'webviews_new_thread'
export const PAGE_TYPE_NOTEPAD = 'notepad'
export const PAGE_TYPE_RECIPE_BONUS = 'recipe_bonus'
export const PAGE_TYPE_REDEEM_RECIPE = 'redeem_recipe'
export const PAGE_TYPE_BILLING_ADDRESS = 'billing_address'
export const PAGE_TYPE_SHIPPING_ADDRESS = 'shipping_address'
export const PAGE_TYPE_ACCOUNT_NEWSLETTER = 'account_newsletter'
export const PAGE_TYPE_SWITCH = 'switchpage'

export const ORDER_PAGES = [
  PAGE_TYPE_ORDERS_LIST,
  PAGE_TYPE_ORDER_OVERVIEW,
  PAGE_TYPE_ORDER_DETAILS
]

export const MESSAGES_PAGES = [
  PAGE_TYPE_THREADS_OVERVIEW,
  PAGE_TYPE_THREAD_DETAILS
]

export const PAGE_TYPES = [
  PAGE_TYPE_CATEGORY,
  PAGE_TYPE_CONTENT,
  PAGE_TYPE_ERROR,
  PAGE_TYPE_HOMEPAGE,
  PAGE_TYPE_ORDERPRINT,
  PAGE_TYPE_PRODUCT,
  PAGE_TYPE_SEARCH_RESULTS,
  PAGE_TYPE_TOPIC_SHOW,
  PAGE_TYPE_CHECKOUT,
  PAGE_TYPE_TOPIC_SHOP,
  PAGE_TYPE_LOGIN,
  PAGE_TYPE_BRANDSHOPS,
  PAGE_TYPE_BRAND_PAGE,
  PAGE_TYPE_DELIVERYTRACKING,
  PAGE_TYPE_ONLINEDOCTORSERVICE,
  PAGE_TYPE_CONFIRMATION,
  PAGE_TYPE_OFFERS,
  PAGE_TYPE_NEWSLETTER,
  PAGE_TYPE_CART_INTERMEDIATE,
  PAGE_TYPE_CART,
  PAGE_TYPE_LEGACY,
  PAGE_TYPE_MARKETING,
  PAGE_TYPE_ACCOUNT,
  PAGE_TYPE_UNKNOWN,
  PAGE_TYPE_WEB_VIEWS_THREAD_NEW,
  PAGE_TYPE_NOTEPAD,
  PAGE_TYPE_RECIPE_BONUS,
  PAGE_TYPE_BILLING_ADDRESS,
  PAGE_TYPE_SHIPPING_ADDRESS,
  PAGE_TYPE_ACCOUNT_NEWSLETTER,
  PAGE_TYPE_REDEEM_RECIPE,
  PAGE_TYPE_SWITCH,
  ...ORDER_PAGES,
  ...MESSAGES_PAGES
]

export const PAGES_WITHOUT_SEARCHBOX = [
  PAGE_TYPE_NOTEPAD, // WSBLUES-45 setting.
  PAGE_TYPE_PRODUCT,
  PAGE_TYPE_ACCOUNT,
  PAGE_TYPE_LOGIN,
  PAGE_TYPE_RECIPE_BONUS,
  PAGE_TYPE_BILLING_ADDRESS,
  PAGE_TYPE_SHIPPING_ADDRESS,
  PAGE_TYPE_ACCOUNT_NEWSLETTER,
  ...ORDER_PAGES,
  ...MESSAGES_PAGES
]
